import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
// Models
import { IMessage } from 'app/models/ChatAI';
// Mui
import { Box, Paper, Typography, Tooltip, IconButton } from '@mui/material';
// Icons
import { BookmarkAddOutlined as BookmarkAddOutlinedIcon } from '@mui/icons-material';
// Dialogs
import AIPromptFormDialog from 'app/dialogs/AIPromptFormDialog';
// Utilities
import { parseDateFromUtcToLocal } from '_utilities/datetime.utility';

interface IProps {
  message: IMessage;
}

export default function HumanMessage({ message }: IProps) {
  const { t } = useTranslation();

  const [ open, setOpen ] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Fragment>
      <Paper
        sx={{
          position: 'relative',
          minWidth: 240,
          maxWidth: '75%',
          alignSelf: 'flex-end',
          px: 4,
          pt: 4,
          pb: 2
        }}
        variant="outlined"
      >
        <Box sx={{ mb: 2 }}>{message.text}</Box>
        {message.createdOn ? (
          <Typography sx={{
            display: 'block',
            textAlign: 'right',
            fontSize: 11
          }} variant="caption">{parseDateFromUtcToLocal(message.createdOn)}</Typography>
        ) : null}
        <Tooltip title={t('pages.aiChat.createPromptButton')}>
          <IconButton
            sx={{
              position: 'absolute',
              left: 0, top: '50%',
              ml: -10,
              transform: 'translateY(-50%)'
            }}
            name="Create prompt"
            onClick={handleOpen}
            size="small"
          ><BookmarkAddOutlinedIcon fontSize="small" /></IconButton>
        </Tooltip>
      </Paper>
      {open ? (
        <AIPromptFormDialog
          open={open}
          onClose={handleClose}
          content={message.text}
        />
      ) : null}
    </Fragment>
  )
}
